<div class="tw-px-0 tw-pb-12.5 tw-pt-10 sm:tw-px-25">
  <div
    class="tw-flex tw-gap-x-7.5 tw-bg-white tw-p-12.5 mb-group:tw-content-start hb-group:tw-flex-col hb-group:tw-items-center hb-group:tw-justify-center hb-group:tw-gap-4 hb-group:tw-text-midnight-green sm:tw-flex-row"
  >
    <ia-icons
      class="tw-mx-auto tw-flex tw-w-[50px] tw-shrink-0 tw-items-center tw-text-circle-checked-filled hb-group:tw-text-cerulean-3 md:tw-mx-0"
      color="currentColor"
      name="circle_check_filled"
    />
    <div>
      <div class="tw-pt-5 tw-font-sans tw-text-lg tw-font-bold sm:tw-pt-0">
        {{ 'screens.confirmation.title' | translate }}
      </div>
      <div class="tw-mt-3 tw-font-sans tw-text-sm">
        {{ 'screens.confirmation.subtitle' | translate }}
      </div>
    </div>
  </div>

  <div
    class="tw-flex tw-items-center tw-justify-center tw-justify-items-start tw-pt-5 mb-group:sm:tw-justify-end"
  >
    <button
      (click)="onComplete()"
      [isProcessing]="false"
      class="tw-h-10.5 tw-font-semibold hb-group:tw-uppercase"
      iaButton
      id="btn-confirmation-complete"
      data-test-id="btn-confirmation-complete"
      size="large"
      type="button"
    >
      {{ 'screens.confirmation.button.complete' | translate }}
    </button>
  </div>
</div>
